module.exports = __webpack_public_path__ + "static/Image1-fc9933bfc92510cff9e6325947d20c8a.png";